'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { ChartData, ChartInterval, ChartManager, ChartRange } from '@benzinga/chart-manager';
import { StockSymbol } from '@benzinga/session';

export const useChart = (
  symbol: StockSymbol,
  from: ChartRange,
  interval: ChartInterval,
  extendedSession?: boolean,
  to?: ChartRange,
  callback?: (chart: ChartData) => void,
) => {
  const session = React.useContext(SessionContext);

  const [chart, setChart] = React.useState<ChartData | undefined>(() => undefined);

  React.useEffect(() => {
    session.getManager(ChartManager).getChart({
      extendedSession,
      from,
      interval,
      symbol,
      to,
    });
  }, [session, symbol, from, interval, extendedSession, to]);

  Hooks.useSubscriber(session.getManager(ChartManager), event => {
    switch (event.type) {
      case 'chart_updated':
        if (event.data.symbol === symbol && event.from === from && event.interval === interval) {
          setChart(event.data);
          callback?.(event.data);
        }
    }
  });

  return chart;
};
